import { useEffect, useState } from "react";
import { useSite } from "contexts/SiteContext";
import "./style.scss";

const DEFAULT_NAME = "VR Premium Studio";

const SplashScreen = ({ exiting }) => {
	const { settings } = useSite();
	const [nameVisible, setNameVisible] = useState(false);
	const [taglineVisible, setTaglineVisible] = useState(false);

	// const studioName = DEFAULT_NAME;
	const studioName = settings?.studio_name || " ";

	useEffect(() => {
		const t1 = setTimeout(() => setNameVisible(true), 380);
		const t2 = setTimeout(() => setTaglineVisible(true), 680);
		return () => {
			clearTimeout(t1);
			clearTimeout(t2);
		};
	}, []);

	return (
		<div className={`splash-screen${exiting ? " splash-screen--exit" : ""}`}>
			<div className="splash-content">
				<div className="splash-logo">
					<img src="/logo.png" alt={studioName} />
				</div>
				<div
					className={`splash-name${nameVisible ? " splash-name--visible" : ""}`}>
					{studioName}
				</div>
				<div
					className={`splash-tagline${taglineVisible ? " splash-tagline--visible" : ""}`}>
					Immersive VR Experience
				</div>
				<div className="splash-bar">
					<div className="splash-bar-fill" />
				</div>
			</div>
		</div>
	);
};

export default SplashScreen;
